// extracted by mini-css-extract-plugin
export var wrapper = "Loader-module--wrapper--1TqWc";
export var spin = "Loader-module--spin--FMzv5";